import VideoUIControls from "./VideoUIControls";
import {
  SET_SIDEBAR_OPEN,
  SET_SIDEBAR_CLOSE,
  useVideoUIDispatch,
  useVideoUI,
} from "../../VideoUIContext";
import { VideoUIActiveTab } from "../../videoUI.types";
import { useChatUnreadCount } from "@core/features/chat";
import { usePlatformStore } from "@platform/store";

export function VideoUIControlsContainer() {
  const dispatch = useVideoUIDispatch();

  const { isSidebarOpen } = useVideoUI();

  const handleMenuClick = (tab: VideoUIActiveTab) => {
    dispatch({ type: SET_SIDEBAR_OPEN, payload: { activeTab: tab } });
  };

  const handleCloseSidebar = () => {
    dispatch({ type: SET_SIDEBAR_CLOSE });
  };

  const unreadCount = useChatUnreadCount();
  const userCircles = usePlatformStore((s) => s.userCircles);

  return (
    <VideoUIControls
      onMenuClick={handleMenuClick}
      closeSidebar={handleCloseSidebar}
      isSidebarOpen={isSidebarOpen}
      unreadCount={unreadCount}
      userCircles={userCircles}
    />
  );
}

export default VideoUIControlsContainer;
